import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';

import { translatedText } from '../../recoil-states/language-state';

import '../../css/nftMarket.css';
import FilterButton from '../../component/FilterButton';
import FilterDropdown from '../../component/FilterDropdown';
import FilterInput from '../../component/FilterInput';
import FilterApplyButton from '../../component/FilterApplyButton';
import SearchForm from '../../component/SearchForm';
import SortDropdown from '../../component/SortDropdown';
import {
	_getNftMarketCategoryHeaderList,
	_getNftMarketCategoryList,
	_getCurrencyList,
	_getNftMarketSortList,
} from '../../function/functions';
import CategoryHeader from '../../component/CategoryHeader';
import Header from '../../component/header';
import Footer from '../../component/Footer';
// import magnifier from "../../assets/icons/magnifier.svg";

export default function Nftmarket() {
	const textData = useRecoilValue(translatedText);

	const [selectedCategory, setSelectedCategory] = useState('');
	const [selectedCurrencyFilter, setSelectedCurrencyFilter] = useState('');
	const [selectedSort, setSelectedSort] = useState('');
	const [minPriceFilter, setMinPriceFilter] = useState('');
	const [maxPriceFilter, setMaxPriceFilter] = useState('');
	const [searchValue, setSearchValue] = useState('');

	const [categoryList, setCategoryList] = useState([]);
	const [categoryHeaderData, setCategoryHeaderData] = useState({});
	const [currencyList, setCurrencyList] = useState([]);
	const [sortList, setSortList] = useState([]);

	useLayoutEffect(() => {
		const categoryListData = _getNftMarketCategoryList();
		const currencyListData = _getCurrencyList();
		const sortListData = _getNftMarketSortList();
		const categoryHeaderData_data = _getNftMarketCategoryHeaderList();

		setCategoryList(categoryListData);
		setCategoryHeaderData(categoryHeaderData_data);
		setSortList(sortListData);
		setCurrencyList(currencyListData);

		setSelectedCategory(categoryListData[0]);
		setSelectedCurrencyFilter(currencyListData[0]);
		setSelectedSort(sortListData[0]);
	}, []);

	const physicalBenefits = [
		'card_chanel.png',
		'card_tagheuer.png',
		'card_danielwellington.png',
		'card_chopard.png',
		'card_7headspa.png',
	];

	return (
		<Container fluid id='nftMarket'>
			<Header />
			<Row className='intro-container'>
				<Row className='marketPlace-intro'>
					<Col className='empty-col' md={0} lg={1} />
					<Col
						className='marketPlace-intro__logo-container'
						md={12}
						lg={4}
					>
						<img
							src={require('../../assets/duman_siba.png')}
							alt='duman shiba'
						/>
					</Col>
					<Col
						className='marketPlace-intro__text-container'
						md={12}
						lg={7}
					>
						<Row>
							<Col>
								<h1>{textData.nftMarket['NFT Marketplace']}</h1>
							</Col>
						</Row>
						<Row>
							<Col>
								<h2>
									{
										textData.nftMarket[
											'what is nft marketplace'
										]
									}
								</h2>
							</Col>
						</Row>
						<Row>
							<Col>
								<span>
									{
										textData.nftMarket[
											'description about NFT Marketplace'
										]
									}
								</span>
							</Col>
						</Row>
					</Col>
					<Col className='empty-col' md={0} lg={1} />
				</Row>
				<Row className='benefit-intro'>
					<Row className='benefit-intro__text-container'>
						<Row>
							<Col className='empty-col' md={0} lg={2} />
							<Col md={12} lg={8}>
								<h2>
									{
										textData.nftMarket[
											'Physical benefits according to level 5'
										]
									}
								</h2>
							</Col>
							<Col className='empty-col' md={0} lg={2} />
						</Row>
						<Row>
							<Col className='empty-col' md={0} lg={2} />
							<Col md={12} lg={9}>
								<span>
									{
										textData.nftMarket[
											'description about Physical benefits according to level 5'
										]
									}
								</span>
							</Col>
							<Col className='empty-col' md={0} lg={2} />
						</Row>
					</Row>
					<Row className='benefit-intro__images-container'>
						<Col className='empty-col' md={0} lg={1} />
						<Col className='benefit-intro__images' md={12} lg={10}>
							<Row className='benefit-intro__images-row'>
								{physicalBenefits.map((item, index) => (
									<Col
										className='benefit-intro__image'
										key={index}
										sm={12}
										md={2}
									>
										<img
											src={require(`../../assets/${item}`)}
											alt={item.slice(5, -4)}
										/>
									</Col>
								))}
							</Row>
						</Col>
						<Col className='empty-col' md={0} lg={1} />
					</Row>
				</Row>
			</Row>
			<Row>
				<Col className='filter-container' lg={3}>
					<Row className='filter-whole filter__header'>
						<Col>
							<span>Filter</span>
						</Col>
					</Row>
					<Row className='konnect-card filter__header'>
						<Col>
							<span>Konnect Card</span>
						</Col>
					</Row>
					<Row className='konnect-card filter__content'>
						<Col xs={6} style={{ paddingright: 5 }}>
							<FilterButton
								text={categoryHeaderData.duman?.title}
							/>
						</Col>
						<Col xs={6} style={{ paddingLeft: 5 }}>
							<FilterButton
								text={categoryHeaderData['mystery box']?.title}
								textalign='center'
							/>
						</Col>
						<Col>
							<FilterButton
								text={
									categoryHeaderData['partners utility NFT']
										?.title
								}
							/>
						</Col>
					</Row>
					<Row className='price filter__header'>
						<Col>
							<span>Price</span>
						</Col>
					</Row>
					<Row className='price filter__content'>
						<Col>
							<FilterDropdown
								list={currencyList}
								value={selectedCurrencyFilter}
								setValue={setSelectedCurrencyFilter}
							/>
						</Col>
						<Col>
							<FilterInput
								inputId='priceMin'
								value={minPriceFilter}
								onChange={e => {
									setMinPriceFilter(e.target.value);
								}}
								width={108}
								placeholder='Min'
							/>
							<span>to</span>
							<FilterInput
								inputId='priceMax'
								value={maxPriceFilter}
								onChange={e => {
									setMaxPriceFilter(e.target.value);
								}}
								width={108}
								placeholder='Max'
							/>
						</Col>
						<Col>
							<FilterApplyButton onClick={() => {}} />
						</Col>
					</Row>
				</Col>
				<Col className='contents-container'>
					<Row className='search-container'>
						<Col className='search__form-container' sm={12} md={9}>
							<SearchForm
								inputId='market-search'
								placeholder='Search by name or trait'
								value={searchValue}
								onChange={e => {
									setSearchValue(e.target.value);
								}}
							/>
						</Col>
						<Col className='search__sort-container' sm={12} md={3}>
							<SortDropdown
								list={sortList}
								value={selectedSort}
								setValue={setSelectedSort}
							/>
						</Col>
					</Row>
					{Object.keys(categoryHeaderData).length > 0 && (
						<CategoryHeader
							categoryHeaderData={categoryHeaderData}
							category={'mystery box'}
						/>
					)}
					<Row className='duman contents__display-items-sum'>
						<Col></Col>
					</Row>
					<Row className='duman contents'>
						{' '}
						{/* 일반 div로 바꿀 수도 있음 */}
						{/* map 돌리는 부분 시작 */}
						<Row className='duman contents__content-row'>
							<Col
								className='duman contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
							<Col
								className='duman contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
							<Col
								className='duman contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
						</Row>
						{/* map 돌리는 부분 끝 */}
						<Row className='duman contents-continue-button-container'></Row>
					</Row>

					<Row className='mystery-box category-container'>
						<Col className='mystery-box category__description'></Col>
						<Col className='mystery-box category__benefit'></Col>
					</Row>
					<Row className='mystery-box contents__display-items-sum'></Row>
					<Row className='mystery-box contents'>
						{' '}
						{/* 일반 div로 바꿀 수도 있음 */}
						{/* map 돌리는 부분 시작 */}
						<Row className='mystery-box contents__content-row'>
							<Col
								className='mystery-box contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
							<Col
								className='mystery-box contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
							<Col
								className='mystery-box contents__content-row__col'
								sm={12}
								md={6}
								lg={4}
							></Col>
						</Row>
						{/* map 돌리는 부분 끝 */}
						<Row className='mystery-box contents-continue-button-container'></Row>
					</Row>
				</Col>
			</Row>
			<Footer />
		</Container>
	);
}
